import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Project } from '../../../domain/models/project';

@Component({
  selector: 'app-create-project',
  templateUrl: './create-project.component.html',
  styleUrls: ['./create-project.component.scss']
})
export class CreateProjectComponent implements OnInit {
  @Output() public onCreateProject: EventEmitter<string>;
  @Output() public onCancel: EventEmitter<void>;

  public projectName: string;

  private formLocked: boolean;

  constructor() {
    this.onCreateProject = new EventEmitter<string>();
    this.onCancel = new EventEmitter<void>();
  }

  ngOnInit() {
    this.formLocked = false;
  }

  projectNameEntered(): Boolean {
    return this.projectName && this.projectName.length > 0;
  }

  createProject(): void {
    if (!this.formLocked) {
      this.formLocked = true;
      this.onCreateProject.emit(this.projectName);
    }
  }

  cancel(): void {
    this.onCancel.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/project-overview/components/create-project/create-project.component.ts